import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation loginMutation($input: LoginInput!) {
		login(input: $input) {
			errors
			viewer {
				actualPersonId
				email
				csrfToken
				permissions
				availableFeatureFlags {
					key
				}
				company {
					modules {
						moduleType
					}
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Login');

	const variables = {input};
	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
